import type { Template } from "@/common/types/templates";
import { TemplateItem } from "./template-item";

export const TemplatesList = ({
  templates,
}: {
  templates: Template[];
}): JSX.Element => {
  return (
    <div className="divide-y">
      {templates.map((template) => (
        <TemplateItem key={template.id} template={template} />
      ))}
    </div>
  );
};
